/** Codes an Edge Function may return. Anything else is logged and replaced. */
export const FUNCTION_ERRORS = {
  not_authenticated: 401,
  superseded: 409,
  save_conflict: 409,
  save_invalid: 400,
  missing_save: 400,
  too_fast: 429,
  batch_stale: 409,
  batch_gap: 409,
  batch_stage: 400,
} as const;

export type FunctionErrorCode = keyof typeof FUNCTION_ERRORS;

/** Client-facing text for farm-batch rejections. Other codes keep their own notices. */
export const FUNCTION_ERROR_MESSAGES = {
  batch_stale: 'That farm batch was already settled.',
  batch_gap: 'A farm batch was skipped.',
  batch_stage: 'That stage cannot be farmed in a batch.',
} as const;

export class TooFastError extends Error {
  constructor(readonly retryAfterMs: number) {
    super('too_fast');
  }
}

export function functionErrorCode(error: unknown): FunctionErrorCode {
  const raw = error instanceof Error ? error.message : '';
  if (Object.prototype.hasOwnProperty.call(FUNCTION_ERRORS, raw)) return raw as FunctionErrorCode;
  return 'save_invalid';
}
